import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex text-sm w-full" }
const _hoisted_2 = { class: "font-raleway" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 0,
  class: "bg-brand-lightGrey font-raleway text-center p-5"
}
const _hoisted_5 = {
  key: 1,
  class: "flex font-raleway items-center justify-center"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "mr-2 fas fa-arrow-left" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Previous ")
const _hoisted_8 = { class: "flex-grow text-center text-bold text-brand-darkBlue" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Next")
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "ml-2 fas fa-arrow-right" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, "Showing " + _toDisplayString(_ctx.leaderboardDisplay), 1),
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.swapFilter())),
        class: "font-raleway ml-auto text-black text-right p-0 underline italic"
      }, " Show " + _toDisplayString(_ctx.swapButton), 1)
    ]),
    _withDirectives(_createVNode("table", {
      class: ["bg-brand-lightGrey rounded font-raleway  text-left w-full text-gray-900", { 'mb-4': _ctx.controls }]
    }, [
      _createVNode("thead", null, [
        _createVNode("tr", null, [
          _createVNode("th", {
            width: "100%",
            class: {
            sorted: _ctx.currentSort === 'email',
            asc: _ctx.currentSortDir === 'asc',
            desc: _ctx.currentSortDir === 'desc',
          }
          }, " Name ", 2),
          _createVNode("th", {
            class: ["text-center", {
            sorted: _ctx.currentSort === 'score',
            asc: _ctx.currentSortDir === 'asc',
            desc: _ctx.currentSortDir === 'desc',
          }]
          }, " Score ", 2)
        ])
      ]),
      _createVNode("tbody", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedScores, (score, index) => {
          return (_openBlock(), _createBlock("tr", {
            class: "bg-brand-lightGrey rounded-lg m-1 p-4",
            key: index
          }, [
            _createVNode("td", null, _toDisplayString(score.name), 1),
            _createVNode("td", _hoisted_3, _toDisplayString(score.score), 1)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 2), [
      [_vShow, _ctx.sortedScores.length > 0]
    ]),
    (_ctx.sortedScores.length === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_4, " No newer entries yet "))
      : _createCommentVNode("", true),
    (_ctx.controls)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("button", {
            class: ["flex-shrink text-brand-darkBlue button", { disabled: _ctx.currentPage <= 1 }],
            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.prevPage(...args)))
          }, [
            _hoisted_6,
            _hoisted_7
          ], 2),
          _createVNode("p", _hoisted_8, " Page " + _toDisplayString(_ctx.currentPage) + " of " + _toDisplayString(Math.ceil(_ctx.filteredScores.length / _ctx.pageSize)), 1),
          _createVNode("button", {
            class: ["flex-shrink text-brand-darkBlue button", { disabled: !_ctx.isANextPage }],
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.nextPage()))
          }, [
            _hoisted_9,
            _hoisted_10
          ], 2)
        ], 512)), [
          [_vShow, _ctx.sortedScores.length !== 0]
        ])
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}